import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { isAuthenticated } from 'utils/auth';
import { ERROR_NOT_LOGGED_IN } from 'utils/messages';

function PrivateRoute({
  authState = true,
  keyParam,
  component: Component,
  ...rest
}) {
  return (
    <Route
      {...rest}
      render={props => {
        if (isAuthenticated() === authState) {
          const key =
            keyParam && props.match && props.match.params
              ? props.match.params[keyParam]
              : undefined;
          return <Component key={key} {...props} />;
        } else if (props.location.isExiting) {
          return null;
        } else if (authState) {
          return (
            <Redirect
              to={{
                pathname: '/login',
                state: {
                  redirectFrom: props.location,
                  error: { message: ERROR_NOT_LOGGED_IN }
                }
              }}
            />
          );
        } else {
          return <Redirect to="/" />;
        }
      }}
    />
  );
}

export default PrivateRoute;
